const checkPlaceholder = (trl: string, placeholder: string): boolean => {
    return trl.includes(placeholder);
};

export default checkPlaceholder;
